// The counted-by-units checkbox + pack-qty input (with its 1/5/10 ק"ג
// quick-fill buttons) + waste-% input — the part of a product's conversion
// shared, byte for byte, between the add-ingredient modal (DishDetailPage's
// add flow) and the standalone conversion modal (its המרה column). Both
// screens write to the SAME product_catalog row, so a change to validation or
// copy applied to only one of them would give two screens different rules for
// one piece of data.
//
// pack_label and the purchase-history table are NOT part of this component —
// they only exist in the standalone conversion modal, which composes them
// around this shared span itself.
const QUICK_FILLS = [['1 ק"ג', 1000], ['5 ק"ג', 5000], ['10 ק"ג', 10000]];

export default function ConversionFields({
  baseUnit, onBaseUnitChange,
  packQty, onPackQtyChange,
  wastePct, onWastePctChange,
  idPrefix, autoFocus,
}) {
  const unitCheckboxId = `${idPrefix}-unit-checkbox`;
  const packQtyId = `${idPrefix}-pack-qty`;
  const wastePctId = `${idPrefix}-waste-pct`;
  const isUnit = baseUnit === 'unit';

  return (
    <>
      <label htmlFor={unitCheckboxId}
        style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.85rem', marginBottom: 10, cursor: 'pointer' }}>
        <input id={unitCheckboxId} type="checkbox" checked={isUnit}
          onChange={e => onBaseUnitChange(e.target.checked ? 'unit' : 'gram')} />
        המוצר נספר ביחידות (לא נשקל)
      </label>

      <div style={{ display: 'flex', gap: 12 }}>
        <div className="form-group" style={{ flex: 1 }}>
          <label htmlFor={packQtyId}>{isUnit ? 'כמה יחידות יש ביחידת הקנייה' : 'כמה גרם יש ביחידת הקנייה'}</label>
          <input id={packQtyId} className="form-control" type="number" min="0" step="any" inputMode="decimal"
            autoFocus={autoFocus}
            style={{ direction: 'ltr', textAlign: 'right' }}
            value={packQty} onChange={e => onPackQtyChange(e.target.value)}
            placeholder={isUnit ? 'לדוגמה: 12' : 'לדוגמה: 1000'} />
          {!isUnit && (
            <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
              {QUICK_FILLS.map(([label, val]) => (
                <button key={val} type="button" className="btn btn-outline btn-sm"
                  onClick={() => onPackQtyChange(String(val))}>{label}</button>
              ))}
            </div>
          )}
        </div>
        <div className="form-group" style={{ flex: 1 }}>
          <label htmlFor={wastePctId} title="מייקר את מחיר המוצר לפי הפחת (קילופים/חיתוך). מחיר ÷ (1 − פחת%).">פחת (%)</label>
          <input id={wastePctId} className="form-control" type="number" min="0" max="99" step="any" inputMode="decimal"
            style={{ direction: 'ltr', textAlign: 'right' }}
            value={wastePct} onChange={e => onWastePctChange(e.target.value)} placeholder="0" />
        </div>
      </div>
    </>
  );
}
